import React from 'react';

import { PageTitle, ProfileDetails } from '../../components';

import { useLocation } from 'react-router-dom';



const ProfileSingle = ({ type, profile: propProfile }) => {
  
  const location = useLocation();
  const profile = propProfile || location.state; // Use propProfile if provided, otherwise get from route state

  if (!profile) return null; // Prevent errors if no profile is available

  const isSpeaker = type === 'speaker';

  return (

    <>

      {/* Page title */}
      <PageTitle title={profile.name} page={isSpeaker ? 'Speaker Single' : 'Team Single'} />

      <section>
        <ProfileDetails profile={profile} isSpeaker={isSpeaker} />
      </section>

    </>

  );
}

export default ProfileSingle;